<template>
    <div class="min-h-screen  px-5 pb-20 lg:pb-52 bg-black bg-opacity-90 p-10">
        <div class="bg-black bg-opacity-20 rounded-lg p-5">
            <img
                class="mx-auto pt-5"
                v-bind:src="$page.props.white_label.data.logo_black"
                width="200"
            />
            <div v-if="error" class="text-center p-5">
                <div class="bg-white bg-opacity-5 rounded-full mx-auto mt-5 lg:mt-10 px-10 py-2 text-center max-w-sm">
                    <span class="text-white font-semibold">ME PARECE QUE O LINK<br>EXPIROU OU É INVÁLIDO</span>
                </div>
                <img class="mx-auto mt-5"
                     :src="require('../../../images/expired_access.png')"
                     width="250"/>
                <div class="mt-4 text-center">
                    <div class="text-gray-300 font-semibold text-sm md:text-base">
                        <p>Caso tenha dúvidas, fale com a nossa equipe de atendimento através do
                            Whatsapp:</p>
                    </div>
                    <div class="mt-10">
                        <div class="flex justify-center ">
                            <div class="px-1"><img :src="require('../../../images/whatsapp-brands.png')" width="30"/>
                            </div>
                            <div class="px-1"><a href="https://api.whatsapp.com/send/?phone=5511970234560"><span
                                class="text-2xl text-yellow-300 font-bold">(11) 97023-4560</span></a></div>
                        </div>
                    </div>
                </div>

            </div>
            <div v-else class="text-center">
                <div class="bg-white bg-opacity-5 rounded-full mx-auto mt-5 lg:mt-10 px-10 py-2 text-center max-w-sm">
                    <span class="text-white text-xs md:text-base font-semibold">DOCUMENTO VÁLIDO</span>
                </div>

                <p class="mx-auto my-20 text-sm md:text-base lg:mt-10 text-gray-300 max-w-3xl text-justify">
                    <p class="mt-5 text-white">{{data.validation.message}}</p>
                    <p class="mt-5 text-white">Identificador da consulta {{data.validation.identifier}}</p>

                    <p class="mt-5 text-white">Consulta realizada por <a class="font-bold" target="_blank" :href="getLink(validateBy)">{{validatedBy}}</a></p>
                </p>
                <div class="my-5">
                    <div class="px-5 mt-10">
                        <button
                            class="text-xs md:text-sm font-bold py-3 px-3 md:px-6 rounded-full uppercase bg-yellow-300 hover:bg-yellow-400"
                            @click="downloadFile"
                        >
                            BAIXAR DOCUMENTO
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import AppLayout from "../../Layouts/AppLayout.vue";
import JetButton from "../../Jetstream/Button.vue";

export default {
    props: ["code", "error", "mobile_settings", "data"],
    components: {
        AppLayout,
        JetButton
    },
    data() {
        return {
            userPlatform: this.mobile_settings?.platform || "Unknown",
            mobileAppData: this.mobile_settings?.mobile_ib || {
                name: "2GO Bank",
                google_app_id: "com.ib2gopag.app",
                google_store_url: "https://play.google.com/store/apps/details?id=com.ib2gopag.app",
                apple_store_url: "https://apps.apple.com/tm/app/2go-bank/id1603338816",
            }
        };
    },
    computed:{
        validatedBy(){
            return this.data.request.source === "serpro"
                ? "SERPRO" : "BIGDATA";
        }
    },
    methods:{
        getLink(value){
            if (value === "SERPRO"){
                return "https://www.serpro.gov.br"
            }
            return "https://bigdatacorp.com.br";
        },
        downloadFile(){
            window.location.href = this.data.request.file
        },
    }
};
</script>
